import React from 'react';
import $ from "jquery";
import DatePicker from 'react-datepicker';
import moment from 'moment';
import 'moment/locale/de';
import {_GPY,__GPYPost , __GPYGet} from '../../../env.js'
import 'react-datepicker/dist/react-datepicker.css';
import WaitCube from '../../../WaitCube.js'
import GpyFileUpload from '../lib/GpyFileUpload.js'
import I18nString from '../../../I18nString.js'

class Game extends React.Component {

	constructor(props) {
			super(props);
			this.state = {
						teamsIsLoaded: false,
						teams: {},
						homeLogo : undefined,
						guestLogo : undefined,
						currentGame:  {id : -1, gameName: "", homeRole:"HOME_TEAM",guestRole:"GUEST_TEAM",sponsorPk:-1 ,streamUrl:"", logo:"", _endTime: moment().toDate(), _startTime: moment().toDate(),startTime: moment().valueOf(), endTime: moment().valueOf(), homeTeamPk: -1, guestTeamPk: -1, guestTeamId: "",homeTeamId: ""},
						gamesIsLoaded: false,
						games : {},
						gameUnsave: false,
						guestInvalidTeamId : true,
						homeInvalidTeamId : true,
						sponsors: {},
						sponsorsIsLoaded: false,
						refereesIsLoaded:false,
						referees:[],
						refereeRole:"REFEREE_MAIN",
						referee: -1,
						crewsIsLoaded:false,
						crews:[],
						crewRole:"CREW_COMMENTATOR",
						crew: -1,
			};
	}

	validateGame(obj,valItemId) {
		console.log("validateGame",obj);

		if(obj.homeTeamPk <= 0 && obj.homeTeamId === '') {
			return false;
		}
		if(valItemId !== undefined) {
			if(obj.homeTeamId !== '' && valItemId) {
				return false;
			}
		} else {
				if(obj.homeTeamId !== '' && this.state.valItemId) {
					return false;
				}
		}



		if(obj.guestTeamPk <= 0 && obj.guestTeamId === '') {
			return false;
		}

		if(valItemId!== undefined) {
			if(obj.guestTeamId !== '' && valItemId) {
				return false;
			}
		} else {
				if(obj.guestTeamId !== '' && this.state.valItemId) {
					return false;
				}
		}
		return true;
 }

 deleteGame() {
	 var g = this.state.currentGame;
	 g.del = true;
	 this.setState({currentGame:g}, () => {
		 this.createOrUpdateGame();
	 });
 }

 onGameFileUpload(file) {
	 var obj = this.state.currentGame;
	 obj.logo = file;
	 this.setState({currentGame:obj,
		 gameUnsave: this.validateGame(obj),
	 });
 }

 getSponsors() {

	 __GPYPost('getAdvertisements',{usageType:"SPONSOR"},(res)=>{
		 this.setState({
			 sponsorsIsLoaded: true,
			 sponsors : res,
		 });
	 },(err)=>{
		 this.setState({
			 sponsorsIsLoaded: false,
		 });
	 });

 }


  //  A8OZ3YYLDE
	//
 loadTeamID(prefix,tid) {

		__GPYPost('getTeam',{teamId:tid},(res)=>{
			if(res.Result !== undefined && res.Result.state === 'FAIL') {
				 console.log("getTeam ");
				 var s = this.state;
				 s[prefix+"Logo"] = undefined;
				 s.guestLogo = undefined;
				 s.currentGame[prefix+"TeamPk"] = -2;
				 s.currentGame[prefix+"TeamName"] = -2;
				 s[prefix+"InvalidTeamId"] = true;
				 s.gameUnsave = this.validateGame(this.state.currentGame,true);
				 this.setState(s);
			} else  {
				 var state = this.state;
				 state[prefix + "InvalidTeamId"] = false;
				 state[prefix+"Logo"] = res.Team.logo;
				 state.currentGame[prefix+"TeamPk"] = -2; //res.Team.id;
				 state.currentGame[prefix+"TeamName"] = res.Team.name;
				 state.gameUnsave = this.validateGame(this.state.currentGame,false);
				 this.setState(state);
			}
		},(err) => {
		});

	}

  onChange(obj,key,unsave,validator,e){
		console.log("onChange(obj,key,unsave,validator,e)",e);
		 e.preventDefault();
		 obj[key] = e.target.value;
		 var state = this.state;
		 state[unsave] = true;
		 if ( validator !== undefined ) {
				 state[unsave] = validator(obj,key);
		 }
		 state.currentGame = obj;
		 this.setState(state);
  }

	onChangeHomeTeam(e) {
			var pk = parseInt (e.target.value);
			if ( this.state.teamsIsLoaded) {
				if(pk<=0) {
					var s = this.state;
					s.homeLogo = undefined;
					s.homeTeamName = undefined;
					s.currentGame.homeTeamPk = pk;
					s.gameUnsave = this.validateGame(this.state.currentGame,true);
					this.setState(s);
					if(pk === -2) {
						$('#homeTeamId').focus();
					}
				} else {
					this.state.teams.Teams.Team.forEach((t) => {
						if(t.id === pk) {
							var state = this.state;
							state.homeLogo = t.logo;
							state.homeTeamName = t.name;
							state.currentGame.homeTeamId = '';
							state.currentGame.homeTeamPk = t.id;
							state.gameUnsave= this.validateGame(state.currentGame);
							this.setState(state);
							return true;
						}
					});
				}
		}
	}
	onChangeSponsor(e) {
		var g = this.state.currentGame;
		g.sponsorPk = e.target.value;
		var valid = this.validateGame(g,true);
		this.setState({ currentGame: g ,gameUnsave:valid});
	}

	onChangeGuestTeamId(e){
 			var g = this.state.currentGame;
 			g.guestTeamId = e.target.value.toUpperCase();

 			if(g.guestTeamId.length === 10) {
 				console.log("loadTeamID " + g.guestTeamId);
 				this.loadTeamID("guest",g.guestTeamId);
 			} else {
 				var s = this.state;
 				s.guestLogo = undefined;
 				s.currentGame.guestTeamPk = -2;
 				s.guestInvalidTeamId = true;
 				s.gameUnsave = this.validateGame(this.state.currentGame,true);
 				this.setState(s);
 			}
   }

	 onChangeHomeTeamId(e){
  			var g = this.state.currentGame;
  			g.homeTeamId = e.target.value.toUpperCase();

  			if(g.homeTeamId.length === 10) {
  				console.log("loadTeamID " + g.homeTeamId);
  				this.loadTeamID("home", g.homeTeamId);
  			} else {
  				var s = this.state;
  				s.homeLogo = undefined;
  				s.currentGame.homeTeamPk = -2;
  				s.homeInvalidTeamId = true;
  				s.gameUnsave = this.validateGame(this.state.currentGame,true);
  				this.setState(s);
  			}
    }

		onChangeCrewId(e){
   			var g = this.state.currentGame;
   			g.crewId = e.target.value.toUpperCase();

   			if(g.crewId.length === 10) {
					__GPYPost('getCrew',{crewId:g.crewId},(res)=>{
						if(res.Result !== undefined && res.Result.state === 'FAIL') {
							 var s = this.state;
							 s.crew = -2;
							 s.currentGame.refereePk = -2;
							 s.invalidcrewId = true;
							 s.currentGame.currentCrew = undefined;
							 s.gameUnsave = this.validateGame(this.state.currentGame,true);
							 this.setState(s);
						} else  {
							 var state = this.state;
							 state.crew = -2;
							 state.currentGame.crewPk = res.Crew.id;
							 state.currentGame.currentCrew = res.Crew;
							 state.invalidRefereeId = false;
							 this.setState(state);
						}
					},(err) => {
					});
   			} else {
   				var s = this.state;
   				s.currentGame.crewPk = -2;
   				s.invalidCrewId = true;
   				s.gameUnsave = this.validateGame(this.state.currentGame,true);
   				this.setState(s);
   			}
     }

		onChangeRefereeId(e){
   			var g = this.state.currentGame;
   			g.refereeId = e.target.value.toUpperCase();
   			if(g.refereeId.length === 10) {
					__GPYPost('getReferee',{refereeId:g.refereeId},(res)=>{
						if(res.Result !== undefined && res.Result.state === 'FAIL') {
							 var s = this.state;
							 s.referee = -2;
							 s.currentGame.refereePk = -2;
							 s.invalidRefereeId = true;
							 s.currentGame.currentReferee = undefined;
							 s.gameUnsave = this.validateGame(this.state.currentGame,true);
							 this.setState(s);
						} else  {
							 var state = this.state;
							 state.referee = -2;
							 state.currentGame.refereePk = res.Referee.id;
							 state.currentGame.currentReferee = res.Referee;
							 state.invalidRefereeId = false;
							 this.setState(state);
						}
					},(err) => {
					});
   			} else {
   				var s = this.state;
   				s.currentGame.refereePk = -2;
   				s.invalidRefereeId = true;
   				s.gameUnsave = this.validateGame(this.state.currentGame,true);
   				this.setState(s);
   			}
     }

	onChangeGuestTeam(e) {
			var pk = parseInt (e.target.value);

			if(pk <= 0){
				var s = this.state;
				s.guestLogo = undefined;
				s.guestTeamName = undefined;
				s.currentGame.guestTeamPk = pk;
				s.currentGame.guestTeamId = '';
				s.guestInvalidTeamId = true;
				s.gameUnsave = this.validateGame(this.state.currentGame,true);
				this.setState(s);
				if(pk === -2) {
					$('#guestTeamId').focus();
				}
			} else if ( this.state.teamsIsLoaded) {
					this.state.teams.Teams.Team.forEach((t) => {
						if(t.id === pk) {

							var st = this.state;
							st.guestInvalidTeamId = true;
							st.currentGame.guestTeamId = '';
							st.guestLogo = t.logo;
							st.guestTeamName = t.name;
							st.currentGame.guestTeamPk = t.id;
							st.gameUnsave = this.validateGame(st.currentGame);
							this.setState(st);
							return true;
						}
					});
				}

	}

  handleChangeStartTime(date) {
			var g = this.state.currentGame
			g.startTime = moment(date).utc().valueOf();
			g._startTime = date;
			g.endTime = moment(date).add(2, 'hours').utc().valueOf();
			g._endTime = moment(date).add(2, 'hours').toDate();

      this.setState({ currentGame: g,gameUnsave: this.validateGame(this.state.currentGame)});
  }

	handleChangeEndTime(date) {
			var g = this.state.currentGame
			g.endTime = moment(date).utc().valueOf();
			g._endTime = date;
			this.setState({ currentGame: g , gameUnsave: this.validateGame(this.state.currentGame)});
	}

	componentDidMount() {
		this.getGames();
		this.getTeams();
		this.getSponsors();
		this.getReferees();
		this.getCrews();
	}

	getReferees(){
		__GPYGet('getReferees',(result)=>{
			this.setState({refereesIsLoaded: true,referees: result.Referees.Referee});
		},(err)=>{
			this.setState({refereesIsLoaded: false});
		});
	}

	getCrews(){
		__GPYGet('getCrews',(result)=>{
			this.setState({crewsIsLoaded: true,crews: result.Crews.Crew});
		},(err)=>{
			this.setState({crewsIsLoaded: false});
		});
	}

	createOrUpdateGame() {
		var game = this.state.currentGame;
		game.startTimestamp = moment(game._startTime).utc().valueOf();
		game.endTimestamp = moment(game._endTime).utc().valueOf();

		console.log("createOrUpdateGame",game);

		if(game.guestTeamPk !== -1 && game.homeTeamPk !== -1 ) {
				__GPYPost('createOrUpdateGame',this.state.currentGame,(res)=>{
					this.setState({
						gamesIsLoaded: true,
						games: res,
						gameUnsave: false,
					});
				});
		}
	}

	getTeams() {
		__GPYGet('getTeams',(res)=>{
			this.setState({
				teamsIsLoaded: true,
				teams: res
			})
		},(err) => {
			this.setState({
				teamsIsLoaded: false,
			})
		});
	}

	getGames(obj) {
		if(obj === undefined) {
			obj = {};
		}
		__GPYPost('getGames',obj,(res)=>{

			console.log("GAMES",res);
			 // FIX
			 res.Games.Game.forEach((t) => {
				 if(t.teams.Team === undefined || t.teams.Team.length === 0) {
					 t.teams.Team = [{id:-1,vsRole:"HOME_TEAM"},{id:-1,vsRole:"GUEST_TEAM"}];
				 }
			 });

			 console.log("GAMES++",res);

			this.setState({
				gamesIsLoaded: true,
				games: res,
			});
		});
	}

  onNewGame(){
			this.setState({homeLogo : undefined, guestLogo : undefined, currentGame:  {id : -1, gameName: "", sponsorPk:-1, homeRole:"HOME_TEAM",guestRole:"GUEST_TEAM", streamUrl:"", logo:"",_endTime: moment().toDate(), _startTime: moment().toDate(), startTime: moment().valueOf(), endTime: moment().valueOf(), homeTeamPk: -1, guestTeamPk: -1, guestTeamId: ""}});
	}

	onChangeOldGames(g) {
				console.log("onChangeOldGames",	g.target.value);
				var pk = parseInt(g.target.value);

				if(this.state.gamesIsLoaded) {
					this.state.games.Games.Game.forEach((t) => {
						if(t.id === pk) {
							this.onSelectGame(t);
							return;
						}
					});
					this.state.games.Games.GuestGame.forEach((t) => {
						if(t.id === pk) {
							this.onSelectGame(t);
							return;
						}
					});
				}
	}

	onSelectGame(g) {

		g._startTime = moment(g.startTime).toDate();
		g._endTime = moment(g.endTime).toDate();

		// set default values
		g.homeTeamPk = -1;
		g.guestTeamPk = -1;

		g.teams.Team.forEach((t) => {

			if(t.vsRole === 'HOME_TEAM') {
				g.homeTeamPk = t.id;
				g.homeTeamId = t.teamId;
				g.homeInvalidTeamId = false;

				if(this.state.teamsIsLoaded) {
					this.state.teams.Teams.Team.forEach((x) => {
							if(t.id === x.id) {
									g.homeTeamPk = t.id;
									g.homeTeamId = '';
									g.homeInvalidTeamId = false;
							}
					});
				}
				this.setState({homeLogo : t.logo,homeInvalidTeamId:g.homeInvalidTeamId});
			}

			if(t.vsRole === 'GUEST_TEAM') {
				g.guestTeamPk = t.id;
				g.guestTeamId = t.teamId;
				g.guestInvalidTeamId = false;

				if(this.state.teamsIsLoaded) {
					this.state.teams.Teams.Team.forEach((x) => {
							if(t.id === x.id) {
									g.guestTeamPk = t.id;
									g.guestTeamId = '';
									g.guestInvalidTeamId = false;
							}
					});
				}
				this.setState({guestLogo : t.logo,guestInvalidTeamId:g.guestInvalidTeamId});;
			}
		});

		console.log("onSelectGame",g);
	  this.setState({currentGame: g, gameUnsave: false});
	}

	onSelectReferee(id) {
		var g = this.state.currentGame;
		g.refereePk = id;
		if(id < 0) {
			g.refereeId = "";
			g.currentReferee = undefined;
		} else {
			var ref = undefined;
			this.state.referees.forEach((r) => {
						if(id === r.id) {
									ref = r;
						}
			});
			g.currentReferee = ref;
		}
		this.setState({referee:id,currentGame:g});
	}

	onSelectCrew(id) {
		var g = this.state.currentGame;
		g.crewPk = id;
		if(id < 0) {
			g.crewId = "";
			g.currentCrew = undefined;
		} else {
			var ref = undefined;
			this.state.crews.forEach((r) => {
						if(id === r.id) {
									ref = r;
						}
			});
			g.currentCrew = ref;
		}
		this.setState({crew:id,currentGame:g});
	}


	addCrewToGame() {
		if(this.state.crew===undefined) {
			return;
		}
		if(this.state.currentGame.currentCrew===undefined) {
			return;
		}

		var game = this.state.currentGame;
		var ref = game.currentCrew;

		if(game.crews === undefined) {
			game.crews = {Crew:[]};
		}
		console.log(game);
	/*	this.state.referees.forEach((r) => {
				if(parseInt(game.refereePk) === r.id) {
							ref = r;
				}
		});
		*/
		console.log("Crew:",ref);
		if(ref !== undefined) {
			var exist = false;
			game.crews.Crew.forEach((r) => {
					if(ref.id === r.id && r.vsRole === this.state.crewRole) {
								exist = true;
								return;
					}
			});
			if(!exist){
				ref = JSON.parse(JSON.stringify(ref));
				ref.vsRole = this.state.crewRole;
				game.crews.Crew.push(ref);
			}
		}
		this.setState({currentGame:game,gameUnsave: this.validateGame(this.state.currentGame) });
	}

  addReferreToGame() {
		if(this.state.referee===undefined) {
			return;
		}
		if(this.state.currentGame.currentReferee===undefined) {
			return;
		}

		var game = this.state.currentGame;
		var ref = game.currentReferee;

		if(game.referees === undefined) {
			game.referees = {Referee:[]};
		}
		console.log(game);
	/*	this.state.referees.forEach((r) => {
				if(parseInt(game.refereePk) === r.id) {
							ref = r;
				}
		});
		*/
		console.log("Referee:",ref);
		if(ref !== undefined) {
			var exist = false;
			game.referees.Referee.forEach((r) => {
					if(ref.id === r.id && r.vsRole === this.state.refereeRole) {
								exist = true;
								return;
					}
			});
			if(!exist){
				ref = JSON.parse(JSON.stringify(ref));
				ref.vsRole = this.state.refereeRole;
				game.referees.Referee.push(ref);
			}
		}
		this.setState({currentGame:game,gameUnsave: this.validateGame(this.state.currentGame) });
	}

	removeCrewFromGame(p) {
		var game = this.state.currentGame;
		if(game.crews === undefined) {
			game.crews = {Crew:[]};
		}
		var tmp = [];
		game.crews.Crew.forEach((r) => {
			console.log(p.id,"!==",r.id,p.id !== r.id,"&&",r.vsRole,"!==",p.vsRole,r.vsRole !== p.vsRole);
				if((p.id !== r.id) || (r.vsRole !== p.vsRole)) {
					console.log("push");
					tmp.push(r);
				}
		});
		game.crews.Crew = tmp;
		this.setState({currentGame:game, gameUnsave: this.validateGame(this.state.currentGame) });
 	}


 	removeRefereeFromGame(p) {
		var game = this.state.currentGame;
		if(game.referees === undefined) {
			game.referees = {Referee:[]};
		}
		var tmp = [];
		game.referees.Referee.forEach((r) => {
			console.log(p.id,"!==",r.id,p.id !== r.id,"&&",r.vsRole,"!==",p.vsRole,r.vsRole !== p.vsRole);
				if((p.id !== r.id) || (r.vsRole !== p.vsRole)) {
					console.log("push");
					tmp.push(r);
				}
		});
		game.referees.Referee = tmp;
		this.setState({currentGame:game, gameUnsave: this.validateGame(this.state.currentGame) });
 	}


	render() {
		var isUnsave = function (unsave ,prefix) {
				if(unsave){
					return prefix + "success";
				} else {
					return prefix + "primary disabled";
				}
		}

		var isUpdate = function (current, prefix) {
				if(current.id>0){
					return prefix + "danger";
				} else {
					return prefix + "danger disabled";
				}
		}

		return (
		<div>
				<div className="row">
				<div className="col-12 col-lg-3 col-xl-3">

						<div className="row pt-2">
								<div className="col-8"><h3>{_GPY.i18n.get('gametype_SoccerFootball_games_gamelist_headline')}</h3></div>
								<div className="col-4 text-right align-bottom"><button type="button" onClick={() => this.onNewGame()} className="btn btn-light btn-sm"><span className="glyphicon glyphicon-plus"/></button></div>
						 </div>

						 <div className="row">
								<div className="col">
									 <div className="list-group">
											{this.state.gamesIsLoaded ? this.state.games.Games.Game.map((t) => {

													if( (t.endTime + (1000*60*60*24) ) > moment().utc().valueOf() )  {

													return (<button key={t.id}onClick={() => this.onSelectGame(t)} className={t.id === this.state.currentGame.id?"list-group-item list-group-item-action list-group-item-success flex-column align-items-start pointer":"list-group-item list-group-item-action flex-column align-items-start pointer"}>
																		<div className="d-flex w-100 justify-content-start"><small>{moment(t.startTime).locale(_GPY.locale).format('LL')} ({moment(t.startTime).locale(_GPY.locale).format('HH:mm')} - {moment(t.endTime).locale(_GPY.locale).format('HH:mm')})</small></div>
																	  <div className="d-flex w-100 justify-content-start"><strong>{t.gameName}</strong></div>
																  	<div className="d-flex w-100 justify-content-start">
																		 {t.logo!==undefined&&t.logo!==""?
																		 <img style={{maxWidth : '100px',maxHeight : '25px'}} src={t.logo!==undefined&&t.logo!==""?_GPY.resource("upload/" + t.logo):_GPY.resource("images/guppyi_logo.png")} className="img-fluid" alt="Guppyi Logo"/>
																		 :""}
																	  </div>
														      </button>);
													} else {
														return "";
													}
											}) :  <WaitCube/>  }

											{this.state.gamesIsLoaded ? this.state.games.Games.GuestGame.map((t) => {

													if( (_GPY.toLocaleMoment(t.startTime) + (1000*60*60))> _GPY.toLocaleMoment(moment()) )  {

												return (<button key={t.id} onClick={() => this.onSelectGame(t)} className={t.id === this.state.currentGame.id?"list-group-item list-group-item-action list-group-item-success flex-column align-items-start pointer":"list-group-item list-group-item-action flex-column align-items-start pointer"}>
																	 <div className="d-flex w-100 justify-content-between">
																		 <small>{t.gameName}</small>
																		 <small>{moment(t.startTime).locale(_GPY.locale).format('LLLL')} ({moment(t.startTime).locale(_GPY.locale).format('h:mm')}-{moment(t.endTime).locale(_GPY.locale).format('h:mm')})</small>
																		 <img style={{maxWidth : '100px',maxHeight : '25px'}} src={t.logo!==undefined&&t.logo!==""?_GPY.resource("upload/" + t.logo):_GPY.resource("images/guppyi_logo.png")} className="img-fluid" alt="Guppyi Logo"/>
																	 </div>
																</button>);
											} else {
												return "";
											}
											}) :  "" }

									 </div>
								 </div>
						 </div>

						 <div className="row p-3">
						 		<div className="col-12"><h5>{_GPY.i18n.get('gametype_SoccerFootball_games_obsolategamelist_headline')}</h5></div>
						  </div>

 						 <div className="row">
 								<div className="col">
 									 <div className="list-group">
									 <select className="form-control" onChange={(e) => this.onChangeOldGames(e)}>
									 	<option value="-1">-</option>
									 {this.state.gamesIsLoaded ? this.state.games.Games.Game.map((t) => {
	 								 			if( _GPY.toLocaleMoment(t.startTime) < _GPY.toLocaleMoment(moment()) )  {
										 			return (<option  key={t.id} value={t.id}>{t.gameName} ({moment(t.startTime).locale('de').format('LL')})</option>);
									 			} else {
													return "";
												}
									 })  :  <option value="-1">loading</option>  }

									 {this.state.gamesIsLoaded ? this.state.games.Games.GuestGame.map((t) =>{
	 								 			if( _GPY.toLocaleMoment(t.startTime) < _GPY.toLocaleMoment(moment()) )  {
										 			return (<option  key={t.id} value={t.id}>{t.gameName} ({moment(t.startTime).locale('de').format('LL')})</option>);
									 			} else {
													return "";
												}
									 })  :  <option value="-1">loading</option>  }

									 </select>
 									 </div>
 								 </div>
 						 </div>

				</div>

				<div className="col-12 col-lg-9 col-xl-9 pt-1">

								<div className="card bg-light">
										<div className="card-header"><I18nString callBack={() => this.forceUpdate() } prefix="gametype_SoccerFootball_games_box_game"/>{_GPY.i18n.get('gametype_SoccerFootball_games_box_game_headline')}</div>
{this.state.currentGame.logo!==undefined&&this.state.currentGame.logo!==""?
										<div className="row p-3">
												<div className="col-12 mt-4 mb-4 text-center">
												<div className="d-flex justify-content-center">
														 <img style={{maxWidth : '600px',maxHeight : '150px'}} src={_GPY.resource("upload/" + this.state.currentGame.logo)} className="img-fluid d-none d-md-block" alt="Banner"/>
														 <img style={{maxWidth : '300px',maxHeight : '75px'}} src={_GPY.resource("upload/" + this.state.currentGame.logo)} className="img-fluid d-xs-block d-sm-block d-md-none" alt="Banner"/>
														 </div>
												</div>
										</div>

:""}
{this.state.currentGame.logo!==undefined&&this.state.currentGame.logo!==""?
										<div className="row">
												<div className="col-12 text-center">
														 <hr/>
												</div>
										</div>
:""}

										<div className="row p-3">


												<div className="col-12 col-md-6  mb-1">

														<div className="form-group">
																<label htmlFor="homeTeam">{_GPY.i18n.get('gametype_SoccerFootball_games_box_game_form_starttime_title')}</label>
																<DatePicker className="form-control" selected={this.state.currentGame._startTime!==undefined?this.state.currentGame._startTime:new Date()} onChange={(e) => this.handleChangeStartTime(e) } showTimeSelect
																						minDate={new Date()}
																						timeFormat="HH:mm"
				    																injectTimes={[
				      																			moment().hours(0).minutes(1),
																							      moment().hours(12).minutes(5),
																							      moment().hours(23).minutes(59)
																							    ]}
																					  dateFormat="dd/MM/yyyy H:mm" locale={_GPY.locale}/>
														</div>

												</div>

												<div className="col-12 col-md-6  mb-1">

														<div className="form-group">
																<label htmlFor="homeTeam">{_GPY.i18n.get('gametype_SoccerFootball_games_box_game_form_endtime_title')}</label>
																<DatePicker className="form-control" selected={this.state.currentGame._endTime!==undefined?this.state.currentGame._endTime:new Date()} onChange={ (d) => this.handleChangeEndTime(d) }
																						showTimeSelect
																						minDate={this.state.currentGame._startTime}
																						timeFormat="HH:mm"
				    																injectTimes={[
				      																			moment().hours(0).minutes(1),
																							      moment().hours(12).minutes(5),
																							      moment().hours(23).minutes(59)
																							    ]}
																					  dateFormat="dd/MM/yyyy H:mm" locale={_GPY.locale}/>
														</div>

												</div>

												<div className="col-12 col-md-6 mb-1">
														<div className="form-group">
																<label htmlFor="gameName">{_GPY.i18n.get('gametype_SoccerFootball_games_box_game_form_gamename_title')}</label>
																<input onChange={(e) => this.onChange(this.state.currentGame,"gameName","gameUnsave",this.validateGame,e)} value={this.state.currentGame.gameName} name="gameName" type="text"  className="form-control" placeholder={_GPY.i18n.get('gametype_SoccerFootball_games_box_game_form_gamename_placeholder')}/>
														</div>
												</div>
												<div className="col-12 col-md-6 mb-1">
														<div className="form-group">
																<label htmlFor="sponsors">{_GPY.i18n.get('gametype_SoccerFootball_games_box_game_form_sponsor_title')}</label>
																<select className="form-control" value={this.state.currentGame.sponsorPk} onChange={(e) => this.onChangeSponsor(e)}>
																	<option value="-1">{_GPY.i18n.get('gametype_SoccerFootball_games_box_game_form_sonsor_defaultvalue')}</option>
																	{this.state.sponsorsIsLoaded ? this.state.sponsors.Advertisements.Advertisement.map((t) =>
																		<option key={t.id} value={t.id}>{t.name}</option>
																	)  :  <option value="-1">{_GPY.i18n.get('component_any_loading')}</option>  }
																</select>
														</div>
												</div>
												<div className="col-12 col-md-12 mb-1">
														<div className="form-group">
																<label htmlFor="streamURL">{_GPY.i18n.get('gametype_SoccerFootball_games_box_game_form_streamurl_title')}</label>
																<input onChange={(e)=>this.onChange(this.state.currentGame,"streamUrl","gameUnsave",this.validateGame,e)} value={this.state.currentGame.streamUrl}  name="streamURL" type="text"  className="form-control" placeholder={_GPY.i18n.get('gametype_SoccerFootball_games_box_game_form_streamurl_placeholder')}/>
														</div>
												</div>


										</div>

										<div className="row">
												<div className="col-12 text-center">
														 <hr/>
												</div>
										</div>

										<div className="row p-3">
													<div className="col-3 col-md-3">
															<div className="form-group">
																	<label htmlFor="homeTeam">{_GPY.i18n.get('gametype_SoccerFootball_games_box_game_form_hometeam_title')}</label>
 																	<select className="form-control" value={this.state.currentGame.homeTeamPk} onChange={(e) => this.onChangeHomeTeam(e)}>
																		<option value="-1">{_GPY.i18n.get('gametype_SoccerFootball_games_box_game_form_hometeam_defaultvalue')}</option>
																		<option value="-2">{_GPY.i18n.get('gametype_SoccerFootball_games_box_game_form_hometeam_guppyiidvalue')}</option>

																		{this.state.teamsIsLoaded ? this.state.teams.Teams.Team.map((t) =>
																				<option  key={t.id} value={t.id} >{t.name}</option>
																		)  :  <option value="-1">{_GPY.i18n.get('component_any_loading')}</option>  }
																	</select>
															</div>
																	<div className="form-group">
																			<label htmlFor="homeTeamId">{_GPY.i18n.get('gametype_SoccerFootball_games_box_game_form_hometeamid_title')} {this.state.homeTeamName}</label>
																			{parseInt(this.state.currentGame.homeTeamPk)===-2?
																			<input onChange={(e)=>this.onChangeHomeTeamId(e)} value={this.state.currentGame.homeTeamId} name="homeTeamId" id="homeTeamId" type="text" className={this.state.currentGame.homeTeamId === '' ? "form-control" : this.state.homeInvalidTeamId ? " border-5 border-danger form-control" : "border-2 border-success form-control"} placeholder={_GPY.i18n.get('gametype_SoccerFootball_games_box_game_form_hometeamid_placeholder')}/>
																			:
																			<input onClick={()=>{this.onChangeHomeTeam({target:{value:-2}})}} value={this.state.currentGame.homeTeamId} type="text" className="form-control" placeholder={_GPY.i18n.get('gametype_SoccerFootball_games_box_game_form_hometeamid_placeholder')} readonly="true"/>
																			}
																	</div>

													</div>

													<div className="col-6 col-md-6 text-center">
																<img style={{maxWidth : '100px', maxHeight: '100px'}} src={this.state.homeLogo!==undefined&&this.state.homeLogo!==""?_GPY.resource("upload/" + this.state.homeLogo):_GPY.resource("images/default_team_logo.png")} className="img-fluid rounded d-none d-md-block float-left" alt="Logo"/>
																<img style={{maxWidth : '50px', maxHeight: '50px'}} src={this.state.homeLogo!==undefined&&this.state.homeLogo!==""?_GPY.resource("upload/" + this.state.homeLogo):_GPY.resource("images/default_team_logo.png")} className="img-fluid rounded d-xs-block d-sm-block d-md-none float-left" alt="Logo"/>
																<span className="m-2"><strong>VS</strong></span>
																<img style={{maxWidth : '100px', maxHeight: '100px'}} src={this.state.guestLogo!==undefined&&this.state.guestLogo!==""?_GPY.resource("upload/" + this.state.guestLogo):_GPY.resource("images/default_team_logo.png")} className="img-fluid rounded d-none d-md-block float-right" alt="Logo"/>
																<img style={{maxWidth : '50px', maxHeight: '50px'}} src={this.state.guestLogo!==undefined&&this.state.guestLogo!==""?_GPY.resource("upload/" + this.state.guestLogo):_GPY.resource("images/default_team_logo.png")} className="img-fluid rounded d-xs-block d-sm-block d-md-none float-right" alt="Logo"/>
													</div>

													<div className="col-3 col-md-3">
															<div className="form-group">
															<label htmlFor="guestTeamName">{_GPY.i18n.get('gametype_SoccerFootball_games_box_game_form_guestteam_title')}</label>

															<select className="form-control" value={this.state.currentGame.guestTeamPk} onChange={(e)=>this.onChangeGuestTeam(e)}>
																<option value="-1">{_GPY.i18n.get('gametype_SoccerFootball_games_box_game_form_guestteam_defaultvalue')}</option>
																<option value="-2">{_GPY.i18n.get('gametype_SoccerFootball_games_box_game_form_guestteam_guppyiidvalue')}</option>
																{this.state.teamsIsLoaded ? this.state.teams.Teams.Team.map((t) =>
																	<option  key={t.id} value={t.id} >{t.name}</option>
																)  :  <option value="-1">{_GPY.i18n.get('component_any_loading')}</option>  }
															</select>
															</div>
															<div className="form-group">
																	<label htmlFor="guestTeamId">{_GPY.i18n.get('gametype_SoccerFootball_games_box_game_form_guestteamid_title')}</label>
																	{parseInt(this.state.currentGame.guestTeamPk)===-2?
																	<input onChange={(e)=>this.onChangeGuestTeamId(e)} value={this.state.currentGame.guestTeamId} name="guestTeamId" id="guestTeamId" type="text" className={this.state.currentGame.guestTeamId === '' ? "form-control" : this.state.guestInvalidTeamId ? " border-5 border-danger form-control" : "border-2 border-success form-control"} placeholder={_GPY.i18n.get('gametype_SoccerFootball_games_box_game_form_guestteamid_placeholder')}/>
																	:
																	<input onClick={()=>{this.onChangeGuestTeam({target:{value:-2}})}} value={this.state.currentGame.guestTeamId}type="text" className="form-control" placeholder={_GPY.i18n.get('gametype_SoccerFootball_games_box_game_form_guestteamid_placeholder')} readonly="true"/>
																	}
															</div>
													</div>

										</div>

										<div className="row">
												<div className="col-12 text-center">
														 <hr/>
												</div>
										</div>

										<div className="row p-3">
												<div className="col-2">
															<div className="form-group">
																	<select className="form-control" value={this.state.referee} onChange={(e) => { this.onSelectReferee(parseInt(e.target.value))}}>
																		<option value="-1">Select</option>
																		<option value="-2">Referee ID</option>
																		{this.state.refereesIsLoaded ? this.state.referees.map((r) =>
																				<option  key={r.id} value={r.id}>{r.firstName} {r.lastName}</option>
																		):""}
																	</select>
															</div>
															{parseInt(this.state.referee) === -2?
															<div className="form-group">
																	<input onChange={(e)=>this.onChangeRefereeId(e)} value={this.state.currentGame.refereeId} name="refereeId" id="refereeId" type="text" className={this.state.currentGame.refereeId === '' ? "form-control" : this.state.invalidRefereeId ? " border-5 border-danger form-control" : "border-2 border-success form-control"} placeholder={_GPY.i18n.get('gametype_SoccerFootball_games_box_game_form_refereerid_placeholder')}/>
															</div>
															:<div className="form-group"><input onClick={(e) => { this.setState({referee:-2})}} value={this.state.currentGame.refereeId} type="text" className="form-control" placeholder={_GPY.i18n.get('gametype_SoccerFootball_games_box_game_form_refereerid_placeholder')} readonly="true"/></div>}

											</div>
											<div className="col-2">
															<div className="form-group">
																	<select className="form-control" value={this.state.refereeRole} onChange={(e) => {this.setState({refereeRole:e.target.value})}}>
																		<option  key="REFEREE_MAIN" value="REFEREE_MAIN">{_GPY.i18n.get('gametype_SoccerFootball_games_referee_role_REFEREE_MAIN')}</option>
																		<option  key="REFEREE_ASSISTANT" value="REFEREE_ASSISTANT">{_GPY.i18n.get('gametype_SoccerFootball_games_referee_role_REFEREE_ASSISTANT')}</option>
																		<option  key="REFEREE_FOURTH" value="REFEREE_FOURTH">{_GPY.i18n.get('gametype_SoccerFootball_games_referee_role_REFEREE_FOURTH')}fourth Referee</option>
																		<option  key="REFEREE_FIFTH" value="REFEREE_FIFTH">{_GPY.i18n.get('gametype_SoccerFootball_games_referee_role_REFEREE_FIFTH')}Fifth official and reserve assistant referee</option>
																	</select>
															</div>

												</div>
												<div className="col-1">
																	{parseInt(this.state.currentGame.refereePk)>0?
																		<button type="button" className="btn btn-success" onClick={()=>{this.addReferreToGame();}}><span className="glyphicon glyphicon-plus"/></button>
																		:
																		<button type="button" className="btn btn-light disabled" ><span className="glyphicon glyphicon-plus"/></button>
																	}

													</div>

													<div className="col-6">
														<div class="card-columns">
																	{this.state.currentGame!==undefined&&this.state.currentGame.referees!==undefined?this.state.currentGame.referees.Referee.map((p)=>
																		<div className="card bg-light" >
																			<img className="card-img-top"  style={{maxWidth : '96%', maxHeight: '96%'}} src={p.profileImage!==undefined&&p.profileImage!==""?_GPY.resource("upload/" + p.profileImage):_GPY.resource("images/default_avatar.jpg")} className="img-fluid m-1" alt=""/>
																			<button className="close" type="button" onClick={(e)=> this.removeRefereeFromGame(p)}><span className="glyphicon glyphicon-remove"/></button>
																			<div class="card-body">
																				<h5 class="card-title">{p.firstName} {p.lastName}</h5>
																				<p class="card-text">{_GPY.i18n.get('gametype_SoccerFootball_games_referee_role_'+p.vsRole)}</p>
	    																</div>
																		</div>
																	):""}
															</div>
													</div>
										</div>

										<div className="row">
												<div className="col-12 text-center">
														 <hr/>
												</div>
										</div>




										<div className="row p-3">
												<div className="col-2">
															<div className="form-group">
																	<select className="form-control" value={this.state.referee} onChange={(e) => { this.onSelectCrew(parseInt(e.target.value))}}>
																		<option value="-1">Select</option>
																		<option value="-2">Crew ID</option>
																		{this.state.crewsIsLoaded ? this.state.crews.map((r) =>
																				<option  key={r.id} value={r.id}>{r.firstName} {r.lastName}</option>
																		):""}
																	</select>
															</div>
															{parseInt(this.state.crew) === -2?
															<div className="form-group">
																	<input onChange={(e)=>this.onChangeCrewId(e)} value={this.state.currentGame.crewId} name="crewId" id="crewId" type="text" className={this.state.currentGame.crewId === '' ? "form-control" : this.state.invalidCrewId ? " border-5 border-danger form-control" : "border-2 border-success form-control"} placeholder={_GPY.i18n.get('gametype_SoccerFootball_games_box_game_form_crewid_placeholder')}/>
															</div>
															:<div className="form-group"><input onClick={(e) => { this.setState({crew:-2})}} value={this.state.currentGame.crewId} type="text" className="form-control" placeholder={_GPY.i18n.get('gametype_SoccerFootball_games_box_game_form_crewid_placeholder')} readonly="true"/></div>}

											</div>
											<div className="col-2">
															<div className="form-group">
																	<select className="form-control" value={this.state.crewRole} onChange={(e) => {this.setState({crewRole:e.target.value})}}>
																		<option  key="CREW_COMMENTATOR" value="CREW_COMMENTATOR">{_GPY.i18n.get('gametype_SoccerFootball_games_crew_role_CREW_COMMENTATOR')}</option>
																		<option  key="CREW_CAMERA_OPERATOR" value="CREW_CAMERA_OPERATOR">{_GPY.i18n.get('gametype_SoccerFootball_games_crew_role_CREW_CAMERA_OPERATOR')}</option>
																		<option  key="CREW_SOUND_TECHNICIAN" value="CREW_SOUND_TECHNICIAN">{_GPY.i18n.get('gametype_SoccerFootball_games_crew_role_CREW_SOUND_TECHNICIAN')}</option>
																		<option  key="CREW_STREAMING_OPERATOR" value="CREW_STREAMING_OPERATOR">{_GPY.i18n.get('gametype_SoccerFootball_games_crew_role_CREW_STREAMING_OPERATOR')}</option>
																		<option  key="CREW_GRAPHIC" value="CREW_GRAPHIC">{_GPY.i18n.get('gametype_SoccerFootball_games_crew_role_CREW_GRAPHIC')}</option>
																		<option  key="CREW_ASSISTANT" value="CREW_ASSISTANT">{_GPY.i18n.get('gametype_SoccerFootball_games_crew_role_CREW_ASSISTANT')}</option>
																	</select>
															</div>

												</div>
												<div className="col-1">
																	{parseInt(this.state.currentGame.crewPk)>0?
																		<button type="button" className="btn btn-success" onClick={()=>{this.addCrewToGame();}}><span className="glyphicon glyphicon-plus"/></button>
																		:
																		<button type="button" className="btn btn-light disabled" ><span className="glyphicon glyphicon-plus"/></button>
																	}

													</div>
													<div className="col-6">
														<div class="card-columns">
																	{this.state.currentGame!==undefined&&this.state.currentGame.crews!==undefined?this.state.currentGame.crews.Crew.map((p)=>
																		<div className="card bg-light" >
																			<img className="card-img-top"  style={{maxWidth : '96%', maxHeight: '96%'}} src={p.profileImage!==undefined&&p.profileImage!==""?_GPY.resource("upload/" + p.profileImage):_GPY.resource("images/default_avatar.jpg")} className="img-fluid m-1" alt=""/>
																			<button className="close" type="button" onClick={(e)=> this.removeCrewFromGame(p)}><span className="glyphicon glyphicon-remove"/></button>
																			<div class="card-body">
																				<h5 class="card-title">{p.firstName} {p.lastName}</h5>
																				<p class="card-text">{_GPY.i18n.get('gametype_SoccerFootball_games_crew_role_'+p.vsRole)}</p>
	    																</div>
																		</div>
																	):""}
															</div>
													</div>
										</div>



										<div className="row">
												<div className="col-12 text-center">
														 <hr/>
												</div>
										</div>




										<div className="row justify-content-end p-3">
												<div className="col-9 col-md-10 col-lg-10">
														<GpyFileUpload title={_GPY.i18n.get('gametype_SoccerFootball_games_box_game_button_uploadbanner_title')} className="btn btn-secondary mr-2" callBack={this.onGameFileUpload.bind(this)}/>
												</div>
												<div className="col-3 col-md-2 col-lg-2 text-right">
														<button type="button" className={isUnsave(this.state.gameUnsave,"btn btn-")} onClick={()=>{if(this.state.gameUnsave){this.createOrUpdateGame()}}}><span className={this.state.currentGame.id>0?"glyphicon glyphicon-ok":"glyphicon glyphicon-plus"}/></button>
														<button type="button" className={isUpdate(this.state.currentGame,"ml-2 btn btn-")} onClick={() => this.deleteGame()}><span className="glyphicon glyphicon-remove"/></button>
												</div>
										</div>

							</div>
				</div>
		</div>

		</div>
		)
	}

}
export default Game;
